import { render, staticRenderFns } from "./ShopDecoration.vue?vue&type=template&id=74fdefcc&scoped=true"
import script from "./ShopDecoration.vue?vue&type=script&lang=js"
export * from "./ShopDecoration.vue?vue&type=script&lang=js"
import style0 from "./ShopDecoration.vue?vue&type=style&index=0&id=74fdefcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fdefcc",
  null
  
)

export default component.exports